import { Box, IconButton, Popover, Stack, Typography, getSpacing } from "@compass/core";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const EnvInfo = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [backendEnv, setBackendEnv] = useState<any>();

  useEffect(() => {
    if (Boolean(anchorEl)) {
      ApiService.home.env().then((response) => {
        debugger;
        setBackendEnv(response);
      });
    }
  }, [anchorEl]);

  return (
    <>
      <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
        <Typography variant="caption">ENV</Typography>
      </IconButton>
      <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
        <Stack spacing="md" p={getSpacing("md")}>
          <Stack spacing="xs">
            <Box>REACT_APP_API_ENDPOINT: {process.env.REACT_APP_API_ENDPOINT}</Box>
            <Box>REACT_APP_SESSION_TIMEOUT_SECONDS: {process.env.REACT_APP_SESSION_TIMEOUT_SECONDS}</Box>
            <Box>HTTPS: {process.env.HTTPS || "false"}</Box>
          </Stack>

          <Stack>
            <pre>{JSON.stringify(backendEnv, null, 4)}</pre>
          </Stack>
        </Stack>
      </Popover>
    </>
  );
};
